import { formatDate } from "@angular/common";
import { CalcTemplate } from "./calctemplate";
import { Component_MAWP } from "./component_mawp";
import { Component_MAEP } from "./component_maep";
import { LTAP_module } from "./ltap_module";
import { Utility } from "./utility";
import { GML_module } from "./gml_module";

export class LTA_module {
  public static intLTA_type: number = -1;
  public static sngtmm: number = -1;
  public static sngss: number = -1;
  public static sngcc: number = -1;
  public static sngRt: number = -1;
  public static sngLamda: number = -1;
  public static strRadio: number = -1;
  public static snggr: number = -1;
  public static sngEdgeofMLL1: number = -1;
  public static sngEdgeofOppoMLL2: number = -1;
  public static sngAxialEdgeofMLL1: number = -1;
  public static sngAxialEdgeofOppoMLL2: number = -1;
  public static selectedAppliedload: string = "";
  public static validationMessage = [];
  public static lmlCalcResult = "";
  public static isExternalPre: boolean = false;

  //for saving in json file 
  public static inpt1_text:string ="";
  public static inpt2_text:string ="";
  public static inpt1:string ="";
  public static inpt2:string ="";
  public static Cmptype:string="";
  public static typearesultval:string="";
  public static typeAradsel:string="";
  public static unitType:string="";
  public static typedamageval:string="";
  static inttypeA_passorfail: number;
  // Add a loading type property: 0 = Internal, 1 = External
  public static intLoadingType: number = -1;
  public static sngPa_s: number = -1;
  public static Pa_L1: number = -1;
  public static Pa_L2: number = -1;
  public static Pa_s: number = -1;
  public static MAEPr: number = -1;
  public static diameterForLmsd: number = -1;
  public static MAEPr_profile: number = -1;

   
  

  LTA_module() {
    LTA_module.LTA_initialize();
  }

  public static LTA_initialize(): void {
    //initialize all the variables
    this.intLTA_type = -1;
    this.sngtmm = -1;
    this.sngss = -1;
    this.sngcc = -1;
    this.sngRt = -1;
    this.sngLamda = -1;
    this.snggr = -1;
    this.sngEdgeofMLL1 = -1;
    this.sngEdgeofOppoMLL2 = -1;
    this.sngPa_s = -1;
    this.Pa_L1 = -1;
    this.Pa_L2 = -1;
    this.Pa_s = -1;
    this.MAEPr = -1;
    Component_MAWP.sngP_d = -1;
    Component_MAEP.sngP_d = -1;
    CalcTemplate.reset_data();

    this.validationMessage = [];
    this.lmlCalcResult = "";
    this.diameterForLmsd = -1;
  }

  private static getActiveComponent() {
    return LTA_module.intLoadingType === 1 ? Component_MAEP : Component_MAWP;
  }

  private static setLoadingTypeAndPreCalc(isExternalPressure?: boolean): void {
    if (typeof isExternalPressure === "boolean") {
      this.intLoadingType = isExternalPressure ? 1 : 0;
    }

    if (isExternalPressure) {
      this.LTAP_calc_Pas_MAEPr_Profile();
    } else {
      this.LTA_Pas_MAPEr();
    }
  }

  private static appendExternalPressureCriterion(
    component: any,
    isExternalPressure?: boolean
  ): number {
    const maeprValue =
      isExternalPressure &&
      (component.strD_class === "LTAP" || component.strD_class === "LTA")
        ? this.MAEPr_profile
        : this.MAEPr;

    const pdValue =
      this.intLoadingType === 1 ? Component_MAEP.sngP_d : Component_MAWP.sngP_d;

    if (Number.isNaN(maeprValue)) {
      return 1;
    }

    const comparisonSign = maeprValue >= pdValue ? ">=" : "<";
    const operationText = maeprValue >= pdValue
      ? "Equipment can be operated at Pe_d."
      : "Equipment cannot be operated at Pe_d.";

    if (component.intUnit_select == 0) {
      this.lmlCalcResult += `MAEP_r = ${maeprValue.toFixed(3)} psi ${comparisonSign} Pe_d = ${pdValue.toFixed(3)} psi ==> ${operationText} <br />`;
    } else {
      this.lmlCalcResult += `MAEP_r = ${maeprValue.toFixed(3)} MPa ${comparisonSign} Pe_d = ${pdValue.toFixed(3)} MPa ==> ${operationText} <br />`;
    }

    return maeprValue >= pdValue ? 0 : 1;
  }

  private static normalizePressureLabels(result: string): string {
    if (this.intLoadingType !== 1) {
      return result;
    }

    return result.replace(/MAWP_r/g, "MAEP_r").replace(/P_d/g, "Pe_d");
  }

  

  public static ReturnLTAValuesAsHTML(): string {
    let result =
      "intLTA_type: " +
      this.intLTA_type +
      "</br>" +
      "sngtmm: " +
      this.sngtmm +
      "</br>" +
      "sngss: " +
      this.sngss +
      "</br>" +
      "sngcc: " +
      this.sngcc +
      "</br>" +
      "sngRt: " +
      this.sngRt +
      "</br>" +
      "sngLamda: " +
      this.sngLamda +
      "</br>" +
      "snggr: " +
      this.snggr +
      "</br>" +
      "sngEdgeofMLL1: " +
      this.sngEdgeofMLL1 +
         "</br>" +
      "sngEdgeofOppoMLL2: " +
      this.sngEdgeofOppoMLL2 +
       "</br>" +
      "sngAxialEdgeofMLL1: " +
      this.sngAxialEdgeofMLL1 +
       "</br>" +
      "sngAxialEdgeofOppoMLL2: " +
      this.sngAxialEdgeofOppoMLL2;
    return result;
  }

  // To calculate PA and MAEPr for LML
  public static LTA_Pas_MAPEr(): void {
    this.LTA_calc_Pas_MAEPr();
  }

  public static LTA_calc_Pas_MAEPr(): number {
    const tc_from_lta = this.sngtmm - CalcTemplate.sngFCAml;
    const result = Component_MAEP.calcExternalAtTc(tc_from_lta);
    this.sngPa_s = result ? result.Pa : NaN;
    this.Pa_L1 = Component_MAEP.initial_pa;
    this.Pa_L2 = Component_MAEP.initial_pa;
    
    // To calculate MAEPr = L / (L1/Pa_L1 + L2/Pa_L2 + s/Pa_s)
    const denom = (this.sngEdgeofMLL1 / this.Pa_L1) + (this.sngEdgeofOppoMLL2 / this.Pa_L2) + (this.sngss / this.sngPa_s);
    if (denom <= 0) {
      console.error("lta_Cal_MAEPr(): Invalid denominator", { denom });
      return NaN;
    }
    this.MAEPr = Component_MAEP.sngL / denom;
    return this.MAEPr;
  }

// Calculate LMLPD MAEPr using the full thickness profile (Y_i / Pa_xi terms)
  public static LTAP_calc_Pas_MAEPr_Profile() : number{
    // per-thickness Pa values are available
    const paProfile = LTAP_module.calculateExternalPaForEachThickness();
    const basePa = Component_MAEP.initial_pa;

    let denom = 0;
    // L1 / Pa + L2 / Pa
    denom += LTAP_module.sngAxialEdgeofMLL1 / basePa;
    denom += LTAP_module.sngAxialEdgeofMLL2 / basePa;

    // For each subdivision i, add L_i / Pa_i, where L_i is the.
    for (let i = 1; i <= LTAP_module.intnum_t_pt; i++) {
      const item = LTAP_module.dataSource[i - 1];
      const paXi = paProfile[i];
      const Li = Number(item.x);
      if (!isNaN(Li) && Li > 0) {
        denom += Li / paXi;
      }
    }
    const maepr = Component_MAEP.sngL / denom;
    this.MAEPr_profile = maepr;
    return maepr;
  }

  public static LTA_calc(isExternalPressure?: boolean): string {
    debugger;
    this.setLoadingTypeAndPreCalc(isExternalPressure);
      
    let aa, Mt: number;
    let key1, key2, key3, key4, key5, key7, key8: number;
    let lmsd_Check: number;
    const component = this.getActiveComponent();
    const isInternalPressure = LTA_module.intLoadingType !== 1;
   this.sngRt = (this.sngtmm - CalcTemplate.sngFCAml) / component.sngtc; // calculate thickness ratio
   if(this.sngRt > 1.0)
   {
    this.sngRt = 1.0;
   }
     LTA_module.diameterForLmsd = isInternalPressure ? component.sngID : component.sngIDo;
    aa =  Math.sqrt(LTA_module.diameterForLmsd * component.sngtc);
    lmsd_Check = 1.8 * Math.sqrt(LTA_module.diameterForLmsd * component.sngtc);
    if (
      component.intEquip === 0 ||
      component.intEquip === 1 ||
      component.intEquip === 5 ||
      component.intEquip === 6 ||
      component.intEquip === 7
    ) {
      // cylinder, cone, piping, tank
      this.sngLamda = (1.285 * this.sngss) / aa; // calculate shell parameter in longitudinal direction
    } else {
      // sphere and formed heads; pick the larger dimension between s and c
      if (this.sngss >= this.sngcc) {
        this.sngLamda = (1.285 * this.sngss) / aa;
      } else {
        this.sngLamda = (1.285 * this.sngcc) / aa;
      }
    }

    if (
      component.strD_class === "LTA" ||
      component.strD_class === "Gouge"
    ) {
      // calculate Folias factor
      if (
        component.intEquip === 0 ||
        component.intEquip === 1 ||
        component.intEquip === 5 ||
        component.intEquip === 6 ||
        component.intEquip === 7
      ) {
        // cylinder, cone, piping, B13.4, B13.8
        if (this.sngLamda > 20.0) {
          this.sngLamda = 20.0;
        }
        Mt =
          1.001 -
          0.014195 * this.sngLamda +
          0.2909 * Math.pow(this.sngLamda, 2) -
          0.09642 * Math.pow(this.sngLamda, 3) +
          0.02089 * Math.pow(this.sngLamda, 4) -
          0.003054 * Math.pow(this.sngLamda, 5) +
          2.957e-4 * Math.pow(this.sngLamda, 6) -
          1.8462e-5 * Math.pow(this.sngLamda, 7) +
          7.1553e-7 * Math.pow(this.sngLamda, 8) -
          1.5631e-8 * Math.pow(this.sngLamda, 9) +
          1.4656e-10 * Math.pow(this.sngLamda, 10);
      } else {
        // sphere and formed heads
        if (this.sngLamda > (1.285 * Utility.PI * component.sngID) / aa) {
          this.sngLamda = (1.285 * Utility.PI * component.sngID) / aa;
        }
        Mt =
          (1.0005 +
            0.49001 * this.sngLamda +
            0.32409 * Math.pow(this.sngLamda, 2)) /
          (1.0 +
            0.50144 * this.sngLamda -
            0.011067 * Math.pow(this.sngLamda, 2));
      }
      CalcTemplate.sngRSF = this.sngRt / (1.0 - (1.0 - this.sngRt) / Mt); // calculate remaining strength factor
    }

    if(this.intLoadingType != 1)
    if (CalcTemplate.sngRSF - CalcTemplate.sngRSF_a < -0.00005) {
      // check the condition RSF >= RSFa
      if (component.intEquip !== 8) {
        // RSF < RSF_a - subtract static head after RSF adjustment to calculate MAWP_r, except for tanks
        CalcTemplate.sngMAWP_r =
          component.sngMAWP *
            (CalcTemplate.sngRSF / CalcTemplate.sngRSF_a) -
          component.sngp_H;
      } else {
        // tanks
        CalcTemplate.sngMFH_r =
          CalcTemplate.sngH_f +
          (CalcTemplate.sngMFH - CalcTemplate.sngH_f) *
            (CalcTemplate.sngRSF / CalcTemplate.sngRSF_a);
      }
    } else {
      if (component.intEquip !== 8) {
        // RSF >= RSF_a - no RSF adjustment, subtract static head to calculate MAWP_r, except for tanks
        CalcTemplate.sngMAWP_r = component.sngMAWP - component.sngp_H;
      } else {
        // tanks
        CalcTemplate.sngMFH_r = CalcTemplate.sngMFH;
      }
    }

    this.lmlCalcResult = "";

    // First criterion -- 2s x 2c box
    if (CalcTemplate.intSCbox === 0) {
      key1 = 0;
      if (component.strD_class === "Gouge") {
        this.lmlCalcResult +=
          "Gouge meets the 2s x 2c box interaction criterion. <br />";
      } else {
        if (this.intLTA_type === 0) {
          this.lmlCalcResult +=
            "LTA meets the 2s x 2c box interaction criterion. <br />";
        } else {
          this.lmlCalcResult +=
            "Groove meets the 2s x 2c box interaction criterion. <br />";
        }
      }
    } else {
      key1 = 1;
      if (component.strD_class === "Gouge") {
        this.lmlCalcResult += `Gouge fails the 2s x 2c box interaction criterion. <font color="red">*Fail*</font> <br />`;
      } else {
        if (this.intLTA_type === 0) {
          this.lmlCalcResult += `LTA fails the 2s x 2c box interaction criterion. <font color="red">*Fail*</font> <br />`;
        } else {
          this.lmlCalcResult += `Groove fails the 2s x 2c box interaction criterion. <font color="red">*Fail*</font> <br />`;
        }
      }
    }

    // Second criterion -- thickness ratio
    const sngRtStr = this.sngRt.toFixed(2).toString();
    if (parseFloat(sngRtStr) - 0.2 > -0.00005) {
      key2 = 0;
      this.lmlCalcResult += `Thickness ratio Rt = ${sngRtStr} >= 0.2 <br />`;
    } else {
      key2 = 1;
      this.lmlCalcResult += `Thickness ratio Rt = ${sngRtStr} < 0.2 <font color="red">*Fail*</font> <br />`;
    }

    // Third criterion -- minimum remaining thickness, tmm - FCAml; 0.05" (1.3mm) for piping, 0.1" (2.5mm) for others
    const typeARadio = parseInt(localStorage.getItem("TypeAradioselection") || "0", 10);
    const isTypeAPipingSelection = typeARadio === 3 || typeARadio === 4;
    const isPipingComponent =
      component.intEquip === 5 ||
      component.intEquip === 6 ||
      component.intEquip === 7 ||
      (!isInternalPressure && isTypeAPipingSelection);

    aa = LTA_module.sngtmm - CalcTemplate.sngFCAml;
    if (component.intUnit_select === 0) {
      // US Customary
      aa = Utility.roundDouble(aa, 3); // asked to modify round to 3 decimal places //shameer 4/6/2023
      const aaStr = aa.toFixed(3).toString();
      if (!isPipingComponent) {
        // vessels & tanks
        if (aa >= 0.1) {
          key3 = 0;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} inch >= 0.1 inch <br />`;
        } else {
          key3 = 1;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} inch < 0.1 inch <font color="red">*Fail*</font> <br />`;
        }
      } else {
        // piping
        if (aa >= 0.05) {
          key3 = 0;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} inch >= 0.05 inch <br />`;
        } else {
          key3 = 1;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} inch < 0.05 inch <font color="red">*Fail*</font> <br />`;
        }
      }
    } else {
      // SI
      const aaStr = aa.toFixed(1).toString();
      if (!isPipingComponent) {
        // vessels & tanks
        if (aa >= 2.5) {
          key3 = 0;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} mm >= 2.5 mm <br />`;
        } else {
          key3 = 1;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} mm < 2.5 mm <font color="red">*Fail*</font> <br />`;
        }
      } else {
        // piping
        if (aa >= 1.3) {
          key3 = 0;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} mm >= 1.3 mm <br />`;
        } else {
          key3 = 1;
          this.lmlCalcResult += `tmm - FCAml = ${aaStr} mm < 1.3 mm <font color="red">*Fail*</font> <br />`;
        }
      }
    }

    // Fourth criterion -- distance to structural discontinuity, Lmsd
    LTA_module.diameterForLmsd = isInternalPressure ? component.sngID : component.sngIDo;
    aa =   Math.sqrt(LTA_module.diameterForLmsd * component.sngtc);
    if (component.intUnit_select == 0) {
      // US Customary
      component.buffer = CalcTemplate.sngLmsd.toFixed(3);
      component.buffer1 = aa.toFixed(3);
      if (CalcTemplate.sngLmsd >= aa) {
        key4 = 0;
        this.lmlCalcResult += `Lmsd = ${component.buffer} inch >= 1.8 * sqrt(ID * tc) = ${lmsd_Check.toFixed(3)} inch <br />`;
      } else {
        key4 = 1;
        this.lmlCalcResult += `Lmsd = ${component.buffer} inch < 1.8 * sqrt(ID * tc) = ${lmsd_Check.toFixed(3)} inch <font color="red">*Fail*</font> <br />`;
      }
    } else {
      // SI
      component.buffer = CalcTemplate.sngLmsd.toFixed(1);
      component.buffer1 = aa.toFixed(1);
      if (CalcTemplate.sngLmsd >= aa) {
        key4 = 0;
        this.lmlCalcResult += `Lmsd = ${component.buffer} mm >= 1.8 * sqrt(ID * tc) = ${lmsd_Check.toFixed(1)} mm <br />`;
      } else {
        key4 = 1;
        this.lmlCalcResult += `Lmsd = ${component.buffer} mm < 1.8 * sqrt(ID * tc)= ${lmsd_Check.toFixed(1)} mm <font color="red">*Fail*</font> <br />`;
      }
    }

    // Fifth criterion -- groove bottom radius
    if (
      (component.strD_class != "Gouge" && this.intLTA_type == 1) ||
      component.strD_class == "Gouge"
    ) {
      aa = 0.5 * (1.0 - this.sngRt) * component.sngtc;
      if (component.intUnit_select == 0) {
        // US Customary
        component.buffer = this.snggr.toFixed(3);
        component.buffer1 = aa.toFixed(3);
        if (this.snggr >= aa) {
          key5 = 0;
          this.lmlCalcResult += `gr = ${component.buffer} inch >= 0.5 * (1 - Rt) * tc = ${component.buffer1} inch <br />`;
        } else {
          key5 = 1;
          this.lmlCalcResult += `gr = ${component.buffer} inch < 0.5 * (1 - Rt) * tc = ${component.buffer1} inch <font color="red">*Fail*</font> <br />`;
        }
      } else {
        // SI
        component.buffer = this.snggr.toFixed(1);
        component.buffer1 = aa.toFixed(1);
        if (this.snggr >= aa) {
          key5 = 0;
          this.lmlCalcResult += `gr = ${component.buffer} mm >= 0.5 * (1 - Rt) * tc = ${component.buffer1} mm <br />`;
        } else {
          key5 = 1;
          this.lmlCalcResult += `gr = ${component.buffer} mm < 0.5 * (1 - Rt) * tc = ${component.buffer1} mm <font color="red">*Fail*</font> <br />`;
        }
      }
    }

    // Sixth criterion -- RSF >= RSFa for long. extent assessment
    if (isInternalPressure) {
      component.buffer = CalcTemplate.sngRSF.toFixed(2);
      component.buffer1 = CalcTemplate.sngRSF_a.toFixed(2);
      if (CalcTemplate.sngRSF - CalcTemplate.sngRSF_a >= -0.00005) {
        this.lmlCalcResult += `RSF = ${component.buffer} >= RSFa = ${component.buffer1} ==> No pressure reduction. <br />`;
      } else {
        this.lmlCalcResult += `RSF = ${component.buffer} < RSFa = ${component.buffer1} ==> Pressure reduction may be required. <br />`;
      }
    }
    else
    {
      key7 = this.appendExternalPressureCriterion(component, isExternalPressure);
      key8 = 0;
    }

    // for LMLPD condition
    if(this.intLoadingType != 1) {
    // Seventh criterion -- Calculate MAWPr
    if (component.intEquip != 8) {
      // cylinders, cones, spheres, heads, piping
      if (component.intUnit_select == 0) {
        // US customary
        component.buffer = CalcTemplate.sngMAWP_r.toFixed(1);
        component.buffer1 = component.sngP_d.toFixed(1);
      } else {
        // SI
        component.buffer = CalcTemplate.sngMAWP_r.toFixed(2);
        component.buffer1 = component.sngP_d.toFixed(2);
      }

      if (CalcTemplate.sngMAWP_r >= component.sngP_d) {
        key7 = 0;
        // Carlos Acero
        // Implementing 7712938
        // https://dev.azure.com/chevron/Surface-Platform/_boards/board/t/SE-Application%20Support%20-%20Kanban/Stories/?workitem=7712938
        
        if (component.strD_class == "Gouge") {
          if (
            key1 === 0 &&
            key2 === 0 &&
            key3 === 0 &&
            key4 === 0 &&
            key5 === 0
          ) {
            if (component.intUnit_select == 0) {
              // US customary
              this.lmlCalcResult += `MAWP_r = ${component.buffer} psi >= P_d = ${component.buffer1} psi ==> Equipment can be operated at P_d. <br />`;
            } else {
              // SI
              this.lmlCalcResult += `MAWP_r = ${component.buffer} MPa >= P_d = ${component.buffer1} MPa ==> Equipment can be operated at P_d. <br />`;
            }
          }
        } else {
          if (
            key1 === 0 &&
            key2 === 0 &&
            key3 === 0 &&
            key4 === 0
          ) {
            if (component.intUnit_select == 0) {
              // US customary
              this.lmlCalcResult += `MAWP_r = ${component.buffer} psi >= P_d = ${component.buffer1} psi ==> Equipment can be operated at P_d. <br />`;
            } else {
              // SI
              this.lmlCalcResult += `MAWP_r = ${component.buffer} MPa >= P_d = ${component.buffer1} MPa ==> Equipment can be operated at P_d. <br />`;
            }
          }
        }
      } else {
        key7 = 1;
        if (component.strD_class == "Gouge") {
          if (!(key1 === 1 ||
            key2 === 1 ||
            key3 === 1 ||
            key4 === 1 ||
            key5 === 1)
          ) {
            if (component.intUnit_select == 0) {
              // US customary
              this.lmlCalcResult += `MAWP_r = ${component.buffer} psi < P_d = ${component.buffer1} psi ==> Equipment can only be operated at MAWP_r. <br />`;
            } else {
              // SI
              this.lmlCalcResult += `MAWP_r = ${component.buffer} MPa < P_d = ${component.buffer1} MPa ==> Equipment can only be operated at MAWP_r. <br />`;
            }
          }
        } else {
          if (!(key1 === 1 ||
            key2 === 1 ||
            key3 === 1 ||
            key4 === 1)
          ) {
            if (component.intUnit_select == 0) {
              // US customary
              this.lmlCalcResult += `MAWP_r = ${component.buffer} psi < P_d = ${component.buffer1} psi ==> based on longitudinal extent. <br />`;
            } else {
              // SI
              this.lmlCalcResult += `MAWP_r = ${component.buffer} MPa < P_d = ${component.buffer1} MPa ==> based on longitudinal extent. <br />`;
            }
          }
        }
      }
    } else {
      // tanks
      component.buffer = CalcTemplate.sngMFH_r.toFixed(2);
      component.buffer1 = CalcTemplate.sngMFH_d.toFixed(2);
      if (CalcTemplate.sngMFH_r >= CalcTemplate.sngMFH_d) {
        key7 = 0;
        if (component.intUnit_select == 0) {
          // US Customary unit
          this.lmlCalcResult += `MFH_r = ${component.buffer} ft >= MFH_d = ${component.buffer1} ft ==> Equipment can be operated at MFH_d. <br />`;
        } else {
          // SI unit
          this.lmlCalcResult += `MFH_r = ${component.buffer} m >= MFH_d = ${component.buffer1} m ==> Equipment can be operated at MFH_d. <br />`;
        }
      } else {
        key7 = 1;
        if (component.intUnit_select == 0) {
          // US Customary unit
          this.lmlCalcResult += `MFH_r = ${component.buffer} ft < MFH_d = ${component.buffer1} ft ==> Equipment can only be operated at MFH_r. <br />`;
        } else {
          // SI unit
          this.lmlCalcResult += `MFH_r = ${component.buffer} m < MFH_d = ${component.buffer1} m ==> Equipment can only be operated at MFH_r. <br />`;
        }
      }
    } // end criterion #7
    }
       // for LMLPD condition
    if(this.intLoadingType != 1) {
    // Eighth criterion -- circumferential extent for cylinders, cones, piping and tanks
    if (
      component.intEquip === 0 ||
      component.intEquip === 1 ||
      component.intEquip === 5 ||
      component.intEquip === 6 ||
      component.intEquip === 7
    ) {
      aa =
        (2.0 * LTA_module.sngss * component.sngE_c) /
        component.sngE_L;
      if (LTA_module.sngcc <= aa) {
        // 1st criterion => c <= 2s(E_c/E_L)
        key8 = 0;
        if (component.intUnit_select === 0) {
          if (!(key1 === 1 ||
            key2 === 1 ||
            key3 === 1 ||
            key4 === 1)
          ) {
            // US customary
            this.lmlCalcResult += `c = ${LTA_module.sngcc.toFixed(
              3
            )} inch <= 2 x s x (E_c / E_L) = ${aa.toFixed(
              3
            )} inch ==> Circ. extent of the metal loss is acceptable. <br />`;
          }
        } else {
          if (!(key1 === 1 ||
            key2 === 1 ||
            key3 === 1 ||
            key4 === 1)
          ) {
            // SI
            this.lmlCalcResult += `c = ${LTA_module.sngcc.toFixed(
              1
            )} mm <= 2 x s x (E_c / E_L) = ${aa.toFixed(
              1
            )} mm ==> Circ. extent of the metal loss is acceptable. <br />`;
          }
        }
      } else {
        // fail the 1st criterion => c <= 2s(E_c/E_L)
        if (component.intEquip === 6) {
          // storage tanks
          key8 = 1;
          if (component.intUnit_select === 0) {
            if (!(key1 === 1 ||
              key2 === 1 ||
              key3 === 1 ||
              key4 === 1)
            ) {
              // US customary
              this.lmlCalcResult += `c = ${LTA_module.sngcc.toFixed(
                3
              )} inch > 2 x s x (E_c / E_L) = ${aa.toFixed(
                3
              )} inch ==> Circ. extent of the metal loss is unacceptable. <br />`;
            }
          } else {
            if (!(key1 === 1 ||
              key2 === 1 ||
              key3 === 1 ||
              key4 === 1)
            ) {
              // SI
              this.lmlCalcResult += `c = ${LTA_module.sngcc.toFixed(
                1
              )} mm > 2 x s x (E_c / E_L) = ${aa.toFixed(
                1
              )} mm ==> Circ. extent of the metal loss is unacceptable. <br />`;
            }
          }
        } else {
            if(component.intEquip ===  0 ||  component.intEquip === 5 || component.intEquip === 7) {
              // cylinder 
              key8 = 1;
            if (component.intUnit_select === 0) {
            if (!(key1 === 1 ||
              key2 === 1 ||
              key3 === 1 ||
              key4 === 1)
            ) {
              // US customary
              this.lmlCalcResult += `c = ${LTA_module.sngcc.toFixed(
                3
              )} inch > 2 x s x (E_c / E_L) = ${aa.toFixed(
                3
              )} inch ==> MAWP_r may be limited by the circumferential extent of the LML. <br />`;
            }
          } 
            else {
            if (!(key1 === 1 ||
              key2 === 1 ||
              key3 === 1 ||
              key4 === 1)
            ) {
              // SI
              this.lmlCalcResult += `c = ${LTA_module.sngcc.toFixed(
                1
              )} mm > 2 x s x (E_c / E_L) = ${aa.toFixed(
                1
              )} mm ==> MAWP_r may be limited by the circumferential extent of the LML. <br />`;
            }
          }
          }   
          // cylinders, cones, & piping
          if (CalcTemplate.sngMAWP_r >= component.sngP_d) {
            // pick the smaller of MAWPr and Pd
            aa = component.sngP_d;
          } else {
            aa = CalcTemplate.sngMAWP_r;
          }
          if (component.intEquip === 0) {
            // cylinder
            component.sngtmin_L =
              ((aa + component.sngp_H) * (LTA_module.diameterForLmsd / 2.0)) /
                (2.0 * component.sngS_stress * component.sngE_c +
                  0.4 * (aa + component.sngp_H)) +
              component.sngt_sl;
          } else if (component.intEquip === 1) {
            // cone
            component.sngtmin_L =
              ((aa + component.sngp_H) * LTA_module.diameterForLmsd) /
                (2.0 *
                  Math.cos((component.sngalpha / 360.0) * Math.PI) *
                  (2.0 * component.sngS_stress * component.sngE_c +
                    0.4 * (aa + component.sngp_H))) +
              component.sngt_sl;
          } else if (component.intEquip === 5) {
            // B31.3 piping, no static head
            component.sngtmin_L =
              (aa * component.sngOD) /
                (4.0 *
                  (component.sngS_stress * component.sngE_c +
                    aa * component.sngY_b)) +
              component.sngt_sl;
          }
          aa = LTA_module.sngtmm - CalcTemplate.sngFCAml;
          if (component.sngtmin_L <= aa) {
            key8 = 0;
            if (component.intUnit_select === 0) {
              if (!(key1 === 1 ||
                key2 === 1 ||
                key3 === 1 ||
                key4 === 1)
              ) {
                // US customary
                this.lmlCalcResult +=
                "tmin_L = " +
                component.sngtmin_L.toFixed(3) +
                " inch <= tmm - FCAml = " +
                aa.toFixed(3) +
                " inch ==> Circ. extent of the metal loss is acceptable. <br />";
              }
            } else {
              if (!(key1 === 1 ||
                key2 === 1 ||
                key3 === 1 ||
                key4 === 1)
              ) {
                // SI
                this.lmlCalcResult +=
                "tmin_L = " +
                component.sngtmin_L.toFixed(1) +
                ` mm <= tmm - FCAml = ${aa.toFixed(
                  1
                )} mm ==> Circ. extent of the metal loss is acceptable. <br />`;
              }
            }
          } else {
            key8 = 1;
            CalcTemplate.sngMAWP_rL =
              CalcTemplate.sngMAWP_r * (aa / component.sngtmin_L);
            if (component.intUnit_select === 0) {
              if (!(key1 === 1 ||
                key2 === 1 ||
                key3 === 1 ||
                key4 === 1)
              ) {
                // US customary
                this.lmlCalcResult += `tmin_L = ${component.sngtmin_L.toFixed(
                  3
                )} inch > tmm - FCAml = ${aa.toFixed(
                  3
                )} inch ==> Pressure reduction is required. <br />`;
              }
            } else {
              if (!(key1 === 1 ||
                key2 === 1 ||
                key3 === 1 ||
                key4 === 1)
              ) {
                // SI
                this.lmlCalcResult += `tmin_L = ${component.sngtmin_L.toFixed(
                  1
                )} mm > tmm - FCAml = ${aa.toFixed(
                  1
                )} mm ==> Pressure reduction is required. <br />`;
              }
            }
            this.lmlCalcResult += `MAWP_rL based on the circumferential extent  = ${CalcTemplate.sngMAWP_rL.toFixed(
              component.intUnit_select === 0 ? 1 : 2
            )} ${component.intUnit_select === 0 ? "psi" : "MPa"} <br />`;
          }
        }
      }
    } //end criterion #8
  }

    // Final results
    if (
      (component.strD_class === "LTA" ||
        component.strD_class === "LTAP") &&
      this.intLTA_type === 0
    ) {
      // LTA
      if (component.intEquip > 1 && component.intEquip < 5) {
        // spheres and heads
        if (key1 === 0 && key2 === 0 && key3 === 0 && key4 === 0) {
          component.strD_result += "Pass";
          this.lmlCalcResult += " <br />";
          if (key7 === 0) {
            if (component.intUnit_select === 0) {
              // US customary
              this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                1
              )} psi. (MAWP_r >= P_d).</font> <br />`;
            } else {
              // SI
              this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                2
              )} MPa. (MAWP_r >= P_d).</font> <br />`;
            }
          }
           else {
            if (!(key1 === 1 ||
              key2 === 1 ||
              key3 === 1 ||
              key4 === 1)
            ) {
              //For LMLPD case with extenral pressure,
              const isExternalPressure = LTA_module.intLoadingType === 1;
              const maeprValue = isExternalPressure && component.strD_class === "LTAP"
                ? this.MAEPr_profile
                : this.MAEPr;
              const limitValue = this.intLoadingType !== 1 ? CalcTemplate.sngMAWP_r : maeprValue;

              if (component.intUnit_select === 0) {
                // US customary
                this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${limitValue.toFixed(
                  1
                )} psi. (MAWP_r < P_d).</font> <br />`;
              } else {
                // SI
                this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${limitValue.toFixed(
                  2
                )} MPa. (MAWP_r < P_d).</font> <br />`;
              }
            }
          }
          return this.normalizePressureLabels(this.lmlCalcResult);
        } else {
          component.strD_result += "Fail";
          this.lmlCalcResult += " <br />";
          this.lmlCalcResult += `<font color="red">Local Metal Loss failed the Level 1 assessment. <br /> Consider performing a Local Metal Loss (Profile Data) or Level 3 assesment.</font> <br />`;
          return this.normalizePressureLabels(this.lmlCalcResult);
        }
      } else {
        // cylinders, cone, piping & tanks
        if (key1 === 0 && key2 === 0 && key3 === 0 && key4 === 0) {
          component.strD_result += "Pass";
          if (component.intEquip !== 8) {
            // cylinders, cones, and piping
            if (key8 === 0) {
              // no pressure reduction due to circ. extent
              this.lmlCalcResult += " <br />";
              if (key7 === 0) {
                if (component.intUnit_select === 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                    1
                  )} psi. (MAWP_r >= P_d).</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                    2
                  )} MPa. (MAWP_r >= P_d).</font> <br />`;
                }
              } else {
              //  if (Component_MAWP.intUnit_select === 0) {
                  if (!(key1 === 1 ||
                    key2 === 1 ||
                    key3 === 1 ||
                    key4 === 1)
                  ) {    
                    const maeprValue = isExternalPressure
                      ? this.MAEPr_profile
                      : this.MAEPr;
                    if (Number.isFinite(maeprValue) && maeprValue >= 0) {
                      CalcTemplate.sngMAWP_r = maeprValue;
                    }
                      if (component.intUnit_select === 0) {
                       // US customary
                       this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_r.toFixed(
                         1
                       )} psi. (MAWP_r < P_d).</font> <br />`;
                      } else {
                       // SI
                       this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_r.toFixed(
                         2
                       )} MPa. (MAWP_r < P_d).</font> <br />`;
                      }
                    
                  }  
              }
            }
             else {
              // key8 = 1 ==> further pressure reduction due to circ. extent
              //if (Component_MAWP.intUnit_select === 0) {
                if (!(key1 === 1 ||
                  key2 === 1 ||
                  key3 === 1 ||
                  key4 === 1)
                ) {

                  // for LMLPD case with extenral pressure,
                  const isExternalPressure = this.intLoadingType === 1;
                  const maeprValue =
                  isExternalPressure && component.strD_class === "LTAP"
                  ? this.MAEPr_profile
                  : this.MAEPr;
                  const limitValue =
                  this.intLoadingType !== 1 ? CalcTemplate.sngMAWP_r : maeprValue;
                    const tmmFcaml = LTA_module.sngtmm - CalcTemplate.sngFCAml;
                    let finalValue: number;
                    if (component.sngtmin_L > tmmFcaml) {
                        finalValue = CalcTemplate.sngMAWP_rL;
                    } else {
                        finalValue = limitValue;
                    }
                 
                  if (component.intUnit_select === 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${finalValue.toFixed(
                    1
                  )} psi based on circumferential extent of the LML.</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${finalValue.toFixed(
                    2
                  )} MPa. based on circumferential extent of the LML.</font> <br />`;
                }
              }  
            }
            return this.normalizePressureLabels(this.lmlCalcResult);
          } else {
            // tanks
            if (key8 === 0) {
              // no pressure reduction based on circ. extent
              this.lmlCalcResult += " <br />";
              if (key7 === 0) {
                if (component.intUnit_select === 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design MFH = ${CalcTemplate.sngMFH_d.toFixed(
                    2
                  )} ft. (MFH_r >= MFH_d).</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design MFH = ${CalcTemplate.sngMFH_d.toFixed(
                    2
                  )} m. (MFH_r >= MFH_d).</font> <br />`;
                }
              } else {
                if (component.intUnit_select === 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="blue">Equipment can only be operated at MFH_r = ${CalcTemplate.sngMFH_r.toFixed(
                    2
                  )} ft. (MFH_r < MFH_d).</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="blue">Equipment can only be operated at MFH_r = ${CalcTemplate.sngMFH_r.toFixed(
                    2
                  )} m. (MFH_r < MFH_d).</font> <br />`;
                }
              }
            } else {
              //key8 = 1 ==> no pressure reduction for tanks
              component.strD_result += "Fail";
              this.lmlCalcResult += " <br />";
              this.lmlCalcResult += `<font color="red">Local Metal Loss failed the assessment. <br /> Consider performing a Local Metal Loss (Profile Data) or Level 3 assessment.</font> <br />`;
            }
            return this.normalizePressureLabels(this.lmlCalcResult);
          }
        } else {
          // any of the first 4 criteria is not met
          component.strD_result += "Fail";
          this.lmlCalcResult += " <br />";

          if (component.strD_class === "LTA") {
            this.lmlCalcResult += `<font color="red">Local Metal Loss failed the assessment. <br /> Consider performing a Local Metal Loss (Profile Data) or Level 3 assesment.</font> <br />`;
            return this.normalizePressureLabels(this.lmlCalcResult);
          } else if (component.strD_class === "LTAP") {
            this.lmlCalcResult += `<font color="red">Local Metal Loss failed the assessment. <br /> Consider performing a Level 3 assessment.</font> <br />`;
            return this.normalizePressureLabels(this.lmlCalcResult);
          }
        }
      }
    }
    if (
      (component.strD_class !== "Gouge" && this.intLTA_type == 1) ||
      component.strD_class == "Gouge"
    ) {
      // groove & gouge
      if (component.intEquip > 1 && component.intEquip < 5) {
        // spheres and heads
        if (key1 == 0 && key2 == 0 && key3 == 0 && key4 == 0 && key5 == 0) {
          component.strD_result += "Pass";
          this.lmlCalcResult += " <br />";
          if (key7 == 0) {
            if (component.intUnit_select == 0) {
              // US customary
              this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                1
              )} psi. (MAWP_r >= P_d).</font> <br />`;
            } else {
              // SI
              this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                2
              )} MPa. (MAWP_r >= P_d).</font> <br />`;
            }
          } else {
          //  if (Component_MAWP.intUnit_select == 0) {
              if (!(key1 === 1 ||
                key2 === 1 ||
                key3 === 1 ||
                key4 === 1)
              ) {
                if (component.intUnit_select == 0) {
                // US customary
                this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_r.toFixed(
                  1
                )} psi. (MAWP_r < P_d).</font> <br />`;
              } else {
                // SI
                this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_r.toFixed(
                  2
                )} MPa. (MAWP_r < P_d).</font> <br />`;
              }
            }
          }
          return this.normalizePressureLabels(this.lmlCalcResult);
        } else {
          component.strD_result += "Fail";
          this.lmlCalcResult += " <br />";
          if (component.strD_class == "Gouge") {
            if (key3 == 1 || key4 == 1 || key5 == 1) {
              this.lmlCalcResult += `<font color="red">The Gouge failed Level 1 assessment. <br /> Consider performing a Level 2 or Level 3 assesment.</font> <br />`; // modified by shameer
            } else {
              this.lmlCalcResult += `<font color="red">The Gouge failed Level 1 assessment. <br /> Consider performing a Local Metal Loss (Profile) assesment.</font> <br />`; // modified by shameer
            }
          } else {
            this.lmlCalcResult += `<font color="red">Groove failed the Level 1 assessment. <br /> Consider performing a Level 3 assesment.</font> <br />`;
          }
          return this.normalizePressureLabels(this.lmlCalcResult);
        }
      } else {
        // cylinders, cone, piping & tanks
        if (key1 == 0 && key2 == 0 && key3 == 0 && key4 == 0 && key5 == 0) {
          // cylinders, cones, piping, & tanks
          component.strD_result += "Pass";
          this.lmlCalcResult += " <br />";
          if (component.intEquip != 8) {
            // cylinders, cones, and piping
            if (key8 == 0) {
              // no pressure reduction due to circ. extent
              if (key7 == 0) {
                if (component.intUnit_select == 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                    1
                  )} psi. (MAWP_r >= P_d).</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design pressure = ${component.sngP_d.toFixed(
                    2
                  )} MPa. (MAWP_r >= P_d).</font> <br />`;
                }
              } else {
               // if (Component_MAWP.intUnit_select == 0) {
                  if (!(key1 === 1 ||
                    key2 === 1 ||
                    key3 === 1 ||
                    key4 === 1)
                  ) {
                    if (component.intUnit_select == 0) {
                  const maeprValue =
                  isExternalPressure
                  ? this.MAEPr_profile
                  : this.MAEPr;
                    if (Number.isNaN(maeprValue)) {
                    } else {
                      CalcTemplate.sngMAWP_r = maeprValue;
                    }
                      // US customary
                      this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_r.toFixed(
                        1
                      )} psi. (MAWP_r < P_d).</font> <br />`;
                    
                  } else {
                    // SI
                    this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_r.toFixed(
                      2
                    )} MPa. (MAWP_r < P_d).</font> <br />`;
                  }
                }
              }
            } else {
              // key8 = 1 ==> further pressure reduction due to circ. extent
             // if (Component_MAWP.intUnit_select == 0) {
                if (!(key1 === 1 ||
                  key2 === 1 ||
                  key3 === 1 ||
                  key4 === 1)
                ) {
                  // US customary
                  if (component.intUnit_select == 0) {
                  this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_rL.toFixed(
                    1
                  )} psi based on circumferential extent assessment.</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="orange">Equipment can only be operated at MAWP_r = ${CalcTemplate.sngMAWP_rL.toFixed(
                    2
                  )} MPa. based on circumferential extent assessment.</font> <br />`;
                }
              }
            }
            return this.normalizePressureLabels(this.lmlCalcResult);
          } else {
            // tanks
            if (key8 == 0) {
              // no pressure reduction due to circ. extent
              if (key7 == 0) {
                if (component.intUnit_select == 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design MFH = ${CalcTemplate.sngMFH_d.toFixed(
                    2
                  )} ft. (MFH_r >= MFH_d).</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="blue">Equipment can be operated at design MFH = ${CalcTemplate.sngMFH_d.toFixed(
                    2
                  )} m. (MFH_r >= MFH_d).</font> <br />`;
                }
              } else {
                if (component.intUnit_select == 0) {
                  // US customary
                  this.lmlCalcResult += `<font color="blue">Equipment can only be operated at MFH_r = ${CalcTemplate.sngMFH_r.toFixed(
                    2
                  )} ft. (MFH_r < MFH_d).</font> <br />`;
                } else {
                  // SI
                  this.lmlCalcResult += `<font color="blue">Equipment can only be operated at MFH_r = ${CalcTemplate.sngMFH_r.toFixed(
                    2
                  )} m. (MFH_r < MFH_d).</font> <br />`;
                }
              }
            } else {
              //key8 = 1 ==> no pressure reduction for tanks
              component.strD_result += "Fail";
              if (component.strD_class == "Gouge") {
                if (key3 == 1 || key4 == 1 || key5 == 1) {
                  this.lmlCalcResult += `<font color="red">The Gouge failed Level 1 assessment. <br /> Consider performing a Level 2 or Level 3 assesment.</font> <br />`; // modified by shameer
                } else {
                  this.lmlCalcResult += `<font color="red">The Gouge failed Level 1 assessment. <br /> Consider performing a Local Metal Loss (Profile) assesment.</font> <br />`; // modified by shameer
                }
              } else {
                this.lmlCalcResult += `<font color="red">Groove failed the Level 1 assessment. <br /> Consider performing a Level 3 assesment.</font> <br />`; // modified by shameer
              }
            }
            return this.normalizePressureLabels(this.lmlCalcResult);
          }
        } else {
          // any of the first 5 criteria is not met
          component.strD_result += "Fail";
          this.lmlCalcResult += " <br />";
          if (component.strD_class == "Gouge") {
            if (key3 == 1 || key4 == 1 || key5 == 1) {
              this.lmlCalcResult += `<font color="red">The Gouge failed Level 1 assessment. <br /> Consider performing a Level 2 or Level 3 assesment.</font> <br />`; // added by shameer
            } else {
              this.lmlCalcResult += `<font color="red">The Gouge failed Level 1 assessment. <br /> Consider performing a Local Metal Loss (Profile) assesment.</font> <br />`; // modified by shameer
            }
          } else if (
            component.strD_class == "LTA" ||
            component.strD_class == "LTAP"
          ) {
            this.lmlCalcResult += `<font color="red">Groove failed the Level 1 assessment. <br /> Consider performing a Level 3 assesment.</font> <br />`; // modified by shameer
          }
          return this.normalizePressureLabels(this.lmlCalcResult);
        }
      }
    }

    return this.normalizePressureLabels(this.lmlCalcResult);
  }

  public static check_LTA_Data(inspectionDataFormGroup): boolean {
    let pass_flag: boolean = true;

    this.validationMessage = [];
    let msgNotSet = "not set.";

    const component = this.getActiveComponent();
    const isInternalPressure = LTA_module.intLoadingType !== 1;

  if (component.strD_iclass >= 1 && component.strD_iclass <= 3) {
    let equipmentString: string;

    if (CalcTemplate.intSCbox < 0) {
      this.validationMessage.push(
        "Structural discontinuities not selected\n"
      );
      pass_flag = false;
    }
    

    // textBox1_DI error handling
    if (inspectionDataFormGroup.controls["textBox1_DI"]?.enabled) {
      if (
        component.strD_class == "LTA" ||
        component.strD_class == "Gouge"
      ) {
        equipmentString = "Minimum measured thickness, tmm - ";
        if (!inspectionDataFormGroup.controls["textBox1_DI"].valid) {
              this.validationMessage.push(equipmentString + msgNotSet + "\n");
              pass_flag = false;
            } if (!isInternalPressure && (LTA_module.sngEdgeofMLL1 + LTA_module.sngss + LTA_module.sngEdgeofOppoMLL2) !== Component_MAEP.sngL) {
              this.validationMessage.push(
                'Metal loss length in the axial direction plus the axial distances L_1 and L_2, must be equal to unstiffened / unsupported length, L'
              );
            pass_flag = false;
          }
            
        else {
          if (component.strD_class == "Gouge" || component.strD_class == "LTA") {
            if (LTA_module.sngtmm == 0) {
              this.validationMessage.push(
                equipmentString + "cannot be equal to zero.\n"
              );
              pass_flag = false;
            } else if (LTA_module.sngtmm > Number(component?.sngtrd?.toFixed(3))) {
              this.validationMessage.push(
                equipmentString + "cannot be greater than the current measured thickness.\n"
              );
              pass_flag = false;
            }
          }
        }
      } else if (component.strD_class == "LTAP") {
        equipmentString =
          "Number of thickness measurements in the longitudinal direction, LTAP - ";
        if (!inspectionDataFormGroup.controls["textBox1_DI"].valid) {
          this.validationMessage.push(equipmentString + msgNotSet + "\n");
          pass_flag = false;
        } 
      if (LTAP_module.sngGrid_spacing !== 0) {
          if (!isInternalPressure) {
            const L_1 = LTAP_module.sngAxialEdgeofMLL1;
            const L2 = LTAP_module.sngAxialEdgeofMLL2;
            //const N_read = LTAP_module.intnum_t_pt;
            //const Grid_sp = LTAP_module.sngGrid_spacing;
            const total = L_1 + LTAP_module.sngGrid_spacing + L2;
            const tolerance = 0.000001;
            if (Math.abs(total - Component_MAEP.sngL) >= tolerance) {
              this.validationMessage.push(
                "Metal loss length in the axial direction plus the axial distances L_1 and L_2, must be equal to unstiffened / unsupported length, L"
              );
              pass_flag = false;
            }
          }
        }

        if (LTAP_module.intnum_t_pt <= 0.0) {
          this.validationMessage.push(
            equipmentString + "cannot be less than or equal to 0\n"
          );
          pass_flag = false;
        }
      }
    }
  }
    return pass_flag;
  }

  public static ExportToJson(radioButtonDI: string): string {
    const component = this.getActiveComponent();

    // shameer-start
    let inpt1 = "", inpt2 = "", inpt1_text = "", inpt2_text = "";
    const typeAradio = parseInt(localStorage.getItem("TypeAradioselection"));
    let userinputs: string | null = null;
    let Input_data: any = null;
    let a1: any, a2: any;

    if (typeAradio === 1) {
      userinputs = localStorage.getItem('verticalinputs');
      Input_data = userinputs ? JSON.parse(userinputs) : null;
      a1 = Input_data?.inputvalue1;
      a2 = Input_data?.inputvalue2;
      inpt1 = a1;
      inpt2 = a2;
      if (component.intUnit_select == 0) {
        inpt1_text = "Vertical Location of the Flaw, H (inch)";
        inpt2_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD (inch)";
      } else if (component.intUnit_select == 1) {
        inpt1_text = "Vertical Location of the Flaw, H*  (mm) *";
        inpt2_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
      }
    } else if (typeAradio === 2) {
      userinputs = localStorage.getItem('horizontalinputs');
      Input_data = userinputs ? JSON.parse(userinputs) : null;
      a1 = Input_data?.inputvalue1;
      a2 = Input_data?.inputvalue2;
      inpt1 = a1;
      inpt2 = a2;
      if (component.intUnit_select == 0) {
        inpt1_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (inch) *";
        inpt2_text = "Distance between saddle supports Lss  (inch) *";
      } else if (component.intUnit_select == 1) {
        inpt1_text = "Outside Diameter of Cylindrical or Conical Shell Section, OD  (mm) *";
        inpt2_text = "Distance between saddle supports Lss  (mm) *";
      }
    } else if (typeAradio === 3) {
      userinputs = localStorage.getItem('carbonsteelinputs');
      Input_data = userinputs ? JSON.parse(userinputs) : null;
      a1 = Input_data?.inputvalue1;
      a2 = Input_data?.inputvalue2;
      inpt1 = a1;
      inpt2 = a2;
      if (component.intUnit_select == 0) {
        inpt1_text = "Maximum Operating Temperature, Top  (℉)";
        inpt2_text = "Pipe Nominal size, NPS  (inch)";
      } else if (component.intUnit_select == 1) {
        inpt1_text = "Maximum Operating Temperature, Top  (℃)";
        inpt2_text = "Pipe Nominal size, NPS  (mm)";
      }
    } else if (typeAradio === 4) {
      userinputs = localStorage.getItem('highalloyinputs');
      Input_data = userinputs ? JSON.parse(userinputs) : null;
      a1 = Input_data?.inputvalue1;
      a2 = Input_data?.inputvalue2;
      inpt1 = a1;
      inpt2 = a2;
      if (component.intUnit_select == 0) {
        inpt1_text = "Maximum Operating Temperature, Top  (℉)";
        inpt2_text = "Pipe Nominal size, NPS  (inch)";
      } else if (component.intUnit_select == 1) {
        inpt1_text = "Maximum Operating Temperature, Top  (℃)";
        inpt2_text = "Pipe Nominal size, NPS  (mm)";
      }
    } else if (typeAradio === 5) {
      inpt1 = "";
      inpt2 = "";
      inpt1_text = "";
      inpt2_text = "";
    }

    if(radioButtonDI.toString().toUpperCase() == "radioButton1_DI_enabled".toUpperCase())
        this.Cmptype = Component_MAWP.getComponentType(Component_MAWP.intEquip);
        else if(radioButtonDI.toString().toUpperCase() == "radioButton2_DI_enabled".toUpperCase())
        this.Cmptype = Component_MAEP.getComponentType(Component_MAEP.intEquip);


    let typearesultval = "";
    if (parseInt(localStorage.getItem("TypeAPassorFail")) == 0) {
      typearesultval = "FAIL";
    } else if (parseInt(localStorage.getItem("TypeAPassorFail")) == 1) {
      typearesultval = "PASS";
    }

    let typeAradsel = "";
    if (typeAradio === 1) typeAradsel = "VerticalVessel";
    else if (typeAradio === 2) typeAradsel = "HorizonalVessel";
    else if (typeAradio === 3) typeAradsel = "CarbonandLowAllySteelPiping";
    else if (typeAradio === 4) typeAradsel = "HighAlloyNonFerrousSteelPiping";
    else if (typeAradio === 5) typeAradsel = "SphericalComponents";

    let unitType = "";
    if (component.intUnit_select == 0) unitType = "US";
    else if (component.intUnit_select == 1) unitType = "SI";

    this.typedamageval = radioButtonDI;
    const dataToExport: any = {
      CalcTemplate: { ...CalcTemplate },
      LTA_module: { ...LTA_module },
      typeaData: {
        typeAresult: typearesultval,
        TypeARadioSelect: typeAradsel,
        Input1_text: inpt1_text,
        Input1_value: inpt1,
        Input2_text: inpt2_text,
        Input2_value: inpt2,
        ComponetType: this.Cmptype,
        TypeofUnit: unitType,
      },
    };

    if (radioButtonDI.toString().toUpperCase() === "RADIOBUTTON1_DI_ENABLED") {
      dataToExport.Component_MAWP = { ...Component_MAWP };
    } else if (radioButtonDI.toString().toUpperCase() === "RADIOBUTTON2_DI_ENABLED") {
      dataToExport.Component_MAEP = { ...Component_MAEP };
    }

    const jsonData = JSON.stringify(dataToExport);
    return jsonData;
  }

  public static ImportFromJson(jsonDataResult): void {
    Component_MAWP.MAWP_initialize();
    Component_MAEP.MAEP_initialize();
    LTA_module.LTA_initialize();

    Object.assign(Component_MAWP, jsonDataResult.Component_MAWP);
    Object.assign(Component_MAEP, jsonDataResult.Component_MAEP);
    Object.assign(CalcTemplate, jsonDataResult.CalcTemplate);
    Object.assign(LTA_module, jsonDataResult.LTA_module);
  }

  public static updateInspectionDataFormControls(
    inspectionDataFormGroup
  ): void {
    const formControls = this.getFormControls(inspectionDataFormGroup);
    this.updateRadioButtonAndTextBox6(formControls);
    this.updateTextBox2(formControls);
    this.updateComboBox1(formControls);
    this.updateTextBox1And3(formControls);
    this.updateTextBox4(formControls);
    this.updateTextBox5(formControls);
    this.updateTextBox6(formControls);
    this.textBox5_DI_external(formControls);
  }

  private static getFormControls(inspectionDataFormGroup) {
    return {
      textBox1_DIformControl: inspectionDataFormGroup.get("textBox1_DI"),
      textBox2_DIformControl: inspectionDataFormGroup.get("textBox2_DI"),
      textBox3_DIformControl: inspectionDataFormGroup.get("textBox3_DI"),
      textBox4_DIformControl: inspectionDataFormGroup.get("textBox4_DI"),
      textBox5_DIformControl: inspectionDataFormGroup.get("textBox5_DI"),
      textBox6_DIformControl: inspectionDataFormGroup.get("textBox6_DI_snggr"),
      textBox5_DIformControl_external: inspectionDataFormGroup.get("textBox5_DI_external"),
      textBox6_DIformControl_external: inspectionDataFormGroup.get("textBox6_DI_external"),
      textBox7_DIformControl_external: inspectionDataFormGroup.get("textBox7_DI_external"),
      textBox8_DIformControl_external: inspectionDataFormGroup.get("textBox8_DI_external"),
      comboBox1_DIformControl: inspectionDataFormGroup.get("comboBox1_DI"),
      radioButton_DIformControl: inspectionDataFormGroup.get("radioButton_DI"),
    };
  }

  private static updateRadioButtonAndTextBox6(formControls): void {
  const component = this.getActiveComponent();

  if (component.strD_iclass !== 3 && LTA_module.intLTA_type !== -1) {
    if (LTA_module.intLTA_type === 0) {
      formControls.radioButton_DIformControl.setValue(
        "radioButton1_DI_enabled"
      );
      formControls.textBox6_DIformControl.disable();
    } else if (LTA_module.intLTA_type === 1) {
      formControls.radioButton_DIformControl.setValue(
        "radioButton2_DI_enabled"
      );
      formControls.textBox6_DIformControl.enable();
    }
  }
}

  private static updateTextBox2(formControls): void {
    if (CalcTemplate.sngFCAml !== -1)
      formControls.textBox2_DIformControl.setValue(
        CalcTemplate.sngFCAml.toString()
      );
  }

  private static updateComboBox1(formControls): void {
    let comboBoxValues = ["No", "Yes"];
    if (CalcTemplate.intSCbox !== -1) {
      formControls.comboBox1_DIformControl.setValue(
        comboBoxValues[CalcTemplate.intSCbox]
      );
    }
  }

  private static updateTextBox1And3(formControls): void {
    const component = this.getActiveComponent();

    if (component.strD_iclass === 2) {
      this.updateForLTAP(formControls);
    } else {
      this.updateForLTAAndGouge(formControls);
    }
  }

  private static updateForLTAP(formControls): void {
    if (LTAP_module.intnum_t_pt !== -1)
      formControls.textBox1_DIformControl.setValue(
        LTAP_module.intnum_t_pt.toString()
      );
    if (LTAP_module.sngAxialEdgeofMLL1 !== -1)
      {
        console.log("Updating textBox7_DIformControl_external with value: " + LTAP_module.sngAxialEdgeofMLL1);  
         formControls.textBox7_DIformControl_external.setValue(
        LTAP_module.sngAxialEdgeofMLL1.toString()
    );
    console.log("After Updating textBox7_DIformControl_external with value: " + LTAP_module.sngAxialEdgeofMLL1);  
    }
     
    if (LTAP_module.sngAxialEdgeofMLL2 !== -1){
      console.log("Updating textBox8_DIformControl_external with value: " + LTAP_module.sngAxialEdgeofMLL2);  
        formControls.textBox8_DIformControl_external.setValue(
        LTAP_module.sngAxialEdgeofMLL2.toString()
    );
    console.log("After Updating textBox8_DIformControl_external with value: " + LTAP_module.sngAxialEdgeofMLL2);  
    }
      
    if (LTAP_module.sngGrid_spacing != -1) {
      formControls.textBox3_DIformControl.setValue(
        LTAP_module.sngGrid_spacing.toString()
      );
      if (LTAP_module.sngGrid_spacing === 0) {
        formControls.textBox1_DIformControl.setValue("");
        formControls.textBox1_DIformControl.disable();
      }
    }
  }

  private static updateForLTAAndGouge(formControls): void {
    if (LTA_module.sngtmm != -1)
      formControls.textBox1_DIformControl.setValue(
        LTA_module.sngtmm.toString()
      );
    if (LTA_module.sngss != -1)
      formControls.textBox3_DIformControl.setValue(LTA_module.sngss.toString());
    if (LTA_module.sngEdgeofOppoMLL2 != -1)
     formControls.textBox6_DIformControl_external.setValue(LTA_module.sngEdgeofOppoMLL2.toString());
  }

  private static updateTextBox4(formControls): void {
    if (LTA_module.sngcc !== -1)
      formControls.textBox4_DIformControl.setValue(LTA_module.sngcc.toString());
  }

  private static updateTextBox5(formControls): void {
    if (CalcTemplate.sngLmsd !== -1)
      formControls.textBox5_DIformControl.setValue(
        CalcTemplate.sngLmsd.toString()
      );
  }
  
  private static textBox5_DI_external(formControls): void {
    if (CalcTemplate.sngEdgeofMLL1 !== -1)
      formControls.textBox5_DIformControl_external.setValue(
        CalcTemplate.sngEdgeofMLL1.toString()
      );
  }

  private static updateTextBox6(formControls): void {
    const component = this.getActiveComponent();

    if (LTA_module.intLTA_type === 1 || component.strD_iclass === 3) {
      if (LTA_module.snggr !== 1)
        formControls.textBox6_DIformControl.setValue(
          LTA_module.snggr.toString()
        );
    }
  }

  public static LTA_report(): string {
  this.isExternalPre = GML_module.isExternalLoading === true; 
  let report: string = "";
  const isInternalPressure = LTA_module.intLoadingType !== 1;
  const format = "dd/MM/yyyy";
  const locale = "en-US";
  const dt1 = new Date();
  const reportDate = formatDate(dt1, format, locale);

  const component = this.getActiveComponent();

  report += this.LTA_report_subpart_1(reportDate);
  report += this.LTA_report_subpart_2();
  report += this.LTA_report_subpart_3();

  // SECOND PAGE
  report += this.LTA_report_subpart_4(reportDate);
  if(this.isExternalPre !== true)
  {
  report += `Allowable remaining strength factor, RSFa = ${CalcTemplate.sngRSF_a.toFixed(2)}`;
  }
  report += "<br><br><br>"; // Added <br> for HTML formatting

  report += "Metal Loss Information :<br><br>";

  if (CalcTemplate.intSCbox == 0)
    report += "Major structural discontinuities or other thinned areas infringe on the 2s X 2c box = No</br>";
  else
    report += "Major structural discontinuities or other thinned areas infringe on the 2s X 2c box = Yes</br>";

  if (component.intUnit_select == 0) {
    // US Customary
    report += `Minimum measured thickness, tmm (inch) = ${LTA_module.sngtmm.toFixed(3)}</br>`;
    report += `Future corrosion allowance inside the damage area, FCAml (inch) = ${CalcTemplate.sngFCAml.toFixed(3)}</br>`;
    if(component.strD_class !== "LTAP")
    {
    report += 'Distance from the edge of the metal loss to the nearest stiffening ring, L_1  (inch)= ' + CalcTemplate.sngEdgeofMLL1.toFixed(3) + '</br>';
    report +=  'Distance from the opposite edge of the metal loss to the other stiffening ring, L_2  (inch)= ' + LTA_module.sngEdgeofOppoMLL2.toFixed(3) + '</br>';
    report += `Length of the metal loss in the long. direction, s (inch) = ${LTA_module.sngss.toFixed(3)}</br>`;
    
    }
    else if(!isInternalPressure && component.strD_class === "LTAP"){
    report += 'Axial distance from one edge of the metal loss to the nearest stiffening ring, L_1  (inch)= ' + LTAP_module.sngAxialEdgeofMLL1.toFixed(3) + '</br>';
    report +=  'Axial distance from the opposite edge of the metal loss to the nearest adjacent stiffening ring, L_2  (inch)= ' + LTAP_module.sngAxialEdgeofMLL2.toFixed(3) + '</br>';
    }
    else if(isInternalPressure && component.strD_class === "LTAP")
    {
      report += `Length of the metal loss in the circ. direction, c (inch) = ${LTA_module.sngcc.toFixed(3)}</br>`;
    }

    report += `Distance to structural discontinuity, Lmsd (inch) = ${CalcTemplate.sngLmsd.toFixed(3)}</br>`;
    if(!isInternalPressure && component.strD_class == "LTA")
    {
    report += 'Distance from the edge of the metal loss to the nearest stiffening ring, L_1  (inch)= ' + CalcTemplate.sngEdgeofMLL1.toFixed(3) + '</br>';
    report +=  'Distance from the opposite edge of the metal loss to the other stiffening ring, L_2  (inch)= ' + LTA_module.sngEdgeofOppoMLL2.toFixed(3) + '</br>';
    }
  } else {
    // SI
    report += `Minimum measured thickness, tmm (mm) = ${LTA_module.sngtmm.toFixed(1)}</br>`;
    report += `Future corrosion allowance inside the damage area, FCAml (mm) = ${CalcTemplate.sngFCAml.toFixed(1)}</br>`;
    report += `Length of the metal loss in the long. direction, s (mm) = ${LTA_module.sngss.toFixed(1)}</br>`;
    report += `Length of the metal loss in the circ. direction, c (mm) = ${LTA_module.sngcc.toFixed(1)}</br>`;
    report += `Distance to structural discontinuity, Lmsd (mm) = ${CalcTemplate.sngLmsd.toFixed(1)}</br>`;
  if(!isInternalPressure && component.strD_class == "LTA"){
    report += 'Distance from the edge of the metal loss to the nearest stiffening ring, L_1  (mm)= ' + CalcTemplate.sngEdgeofMLL1.toFixed(1) + '</br>';
    report +=  'Distance from the opposite edge of the metal loss to the other stiffening ring, L_2  (mm)= ' + LTA_module.sngEdgeofOppoMLL2.toFixed(1) + '</br>';
  }
}

  if (
    component.strD_class == "Gouge" ||
    (component.strD_class != "Gouge" && LTA_module.intLTA_type == 1)
  ) {
    if (component.intUnit_select == 0) {
      // US Customary
      report += `Radius at the base of the groove-like flaw, gr (inch) = ${LTA_module.snggr.toFixed(4)}`;
    } else {
      report += `Radius at the base of the groove-like flaw, gr (mm) = ${LTA_module.snggr.toFixed(2)}`;
    }
    report += "<br><br>";
  } else {
    report += "<br><br>";
  }

  report += "Assessment Results :<br><br>";
  report += "All the conditions in the Applicability and Limitations section are met.<br><br>";

  report += this.normalizePressureLabels(this.lmlCalcResult);

  return report;
}

 public static LTA_report_subpart_1(reportDate: string): string {
  let report: string = "";

  const component = this.getActiveComponent();

  if (component.strD_class === "Gouge") {
    report +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 12</center>";
    report += "<center>Assessment of Gouges</center></br></br>";
  } else {
    report +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 5</center>";
    if (component.strD_class === "LTA") {
      report += "<center>Assessment of Local Metal Loss</center></br></br>";
    } else {
      report +=
        "<center>Assessment of Local Metal Loss (Profile)</center></br></br>";
    }
  }

  report += reportDate + "</br>";
  report += "Page: 1</br></br></br>";

  const sRefinery: string = "Facility: ";
  const sPlant: string = "Plant: ";
  const sEquipment: string = "Equipment: ";
  const sAnalyst: string = "Analyst: ";

  report += sRefinery + component.strFacility + "</br>";
  report += sPlant + component.strPlant + "</br>";
  report += sEquipment + component.strEquipment + "</br>";
  report += sAnalyst + component.strAnalyst + "</br></br></br>";

  report += "Applicability and Limitations :</br></br>";

  report += `  
    <ol class="appAndLimitList">  
      <li>The original design criteria were in accordance with a recognized code or standard.</li>  
      <li>The component is not operating in the creep range. The design temperature is less than or equal to the temperature limit in Table 4.1.</li>`;

  if (component.strD_class === "Gouge") {
    report +=
      "<li>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment. Note that cold work may be produced by the deformation. This cold worked area may be more susceptible to some forms of mechanical and environmental cracking.</li>";
  } else {
    report +=
      "<li>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment.</li>";
  }

  report += `
      <li>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</li>  
      <li>Type A components subject to internal pressure or external pressure. Type A components have a design equation that specifically relates pressure and/or other loads to a required wall thickness. Examples are:  
        <ol type="a" class="appAndLimitList">  
          <li>Pressure vessel cylindrical and conical shell sections satisfying the dimensions criteria</li>  
          <li>Spherical pressure vessels and storage spheres</li>  
          <li>Spherical, elliptical and torispherical formed heads</li>  
          <li>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria</li>  
          <li>Cylindrical atmospheric storage tank shell courses</li>  
        </ol>  
      </li>  
    </ol>  
    </br>`;

  // Type A Component Screening Result
  report += "Type A Component Screening Result:</br>";

  const typeAradio = parseInt(localStorage.getItem("TypeAradioselection"));
  if (typeAradio == 1) {
    const userinputs = localStorage.getItem('verticalinputs');
    const Input_data = userinputs ? JSON.parse(userinputs) : null;
    const a1 = Input_data?.inputvalue1;
    const a2 = Input_data?.inputvalue2;

    if (component.intUnit_select == 0) {
      const lbl1 = "\nVertical Location of the Flaw, H (inch) = ";
      const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD (inch) = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    } else if (component.intUnit_select == 1) {
      const lbl1 = "\nVertical Location of the Flaw, H*  (mm) * = ";
      const lbl2 = "\n\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    }
  } else if (typeAradio == 2) {
    const userinputs = localStorage.getItem('horizontalinputs');
    const Input_data = userinputs ? JSON.parse(userinputs) : null;
    const a1 = Input_data?.inputvalue1;
    const a2 = Input_data?.inputvalue2;

    if (component.intUnit_select == 0) {
      const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (inch) * = ";
      const lbl2 = "\n\nDistance between saddle supports Lss  (inch) * = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    } else if (component.intUnit_select == 1) {
      const lbl1 = "\nOutside Diameter of Cylindrical or Conical Shell Section, OD  (mm) * = ";
      const lbl2 = "\n\nDistance between saddle supports Lss  (mm) * = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    }
  } else if (typeAradio == 3) {
    const userinputs = localStorage.getItem('carbonsteelinputs');
    const Input_data = userinputs ? JSON.parse(userinputs) : null;
    const a1 = Input_data?.inputvalue1;
    const a2 = Input_data?.inputvalue2;

    if (component.intUnit_select == 0) {
      const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = ";
      const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    } else if (component.intUnit_select == 1) {
      const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = ";
      const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    }
  } else if (typeAradio == 4) {
    const userinputs = localStorage.getItem('highalloyinputs');
    const Input_data = userinputs ? JSON.parse(userinputs) : null;
    const a1 = Input_data?.inputvalue1;
    const a2 = Input_data?.inputvalue2;

    if (component.intUnit_select == 0) {
      const lbl1 = "\nMaximum Operating Temperature, Top  (℉) = ";
      const lbl2 = "\n\nPipe Nominal size, NPS  (inch) = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    } else if (component.intUnit_select == 1) {
      const lbl1 = "\nMaximum Operating Temperature, Top  (℃) = ";
      const lbl2 = "\n\nPipe Nominal size, NPS  (mm) = ";
      report += lbl1 + a1 + "</br>" + lbl2 + a2;
    }
  }

  // Type A pass/fail
  this.inttypeA_passorfail = parseInt(localStorage.getItem("TypeAPassorFail")) || 0;
  if (this.inttypeA_passorfail == 1) {
    report += "</br>The component meets the Type A screening criteria.</br></br>";
  } else if (this.inttypeA_passorfail == 0) {
    report += "</br>The component deosn't meet the Type A screening criteria.</br></br>";
  }

  report += "Component Information :</br></br>";

  if (component.intEquip === 0)
    report += "Component type = Cylinder</br>";
  else if (component.intEquip === 1)
    report += "Component type = Cone</br>";
  else if (component.intEquip === 2)
    report += "Component type = Sphere</br>";
  else if (component.intEquip === 3)
    report += "Component type = Elliptical Head</br>";
  else if (component.intEquip === 4)
    report += "Component type = F&D Head</br>";
  else if (component.intEquip === 5)
    report += "Component type = B31.3 Piping</br>";
  else if (component.intEquip === 6)
    report += "Component type = B31.4 Piping</br>";
  else if (component.intEquip === 7)
    report += "Component type = B31.8 Piping</br>";
  else report += "Component type = Tank</br>";

  return report;
}

  public static LTA_report_subpart_2(): string {
  let report: string = "";

  const component = this.getActiveComponent();
  const isExternalPressure = LTA_module.intLoadingType === 1;
  const designPressureLabel = isExternalPressure ? "Design pressure or vessel MAEP" : "Design pressure or vessel MAWP";

  if (component.intUnit_select === 0) {
    // US Customary
    if (component.intEquip !== 6)
      report += `${designPressureLabel} (psi) = ${component.sngP_d.toFixed(1)}</br>`;
    else
      report += `Design Maximum Fill Height (ft) = ${CalcTemplate.sngMFH_d.toFixed(2)}</br>`;
    if (
      !Number.isNaN(component.sngTemp_d) &&
      component.sngTemp_d !== -1
    )
      report += `Design temperature (deg-F) = ${component.sngTemp_d.toFixed(2)}</br>`;
    else report += `Design temperature (deg-F) = N/A</br>`;
    // report += `Inside diameter corrected for FCA as applicable, D (inch) = ${component.sngID.toFixed(3)}</br>`;
    if (component.intEquip !== 6) {
      // non-tanks
      report += `Current measured nominal (uniform) thickness, trd (inch) = ${component.sngtrd.toFixed(2)}</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (inch) = ${component.sngFCA.toFixed(2)}</br>`;
    } else {
      report += `Current measured nominal (uniform) thickness, trd (inch) = N/A</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (inch) = N/A</br>`;
    }
    report += `Future corroded thickness, tc (inch) = ${component.sngtc.toFixed(3)}</br>`;
    if (component.intEquip !== 6) {
      report += `Minimum required thickness, tmin (inch) = ${component.sngtmin.toFixed(3)}</br>`;
      report += `MA${isExternalPressure ? "EP" : "WP"} of the component based on tc, MA${isExternalPressure ? "EP" : "WP"} (psi) = ${component.sngMAWP.toFixed(1)}</br>`;
    } else {
      report += `Maximum Fill Height based on tc, MFH (ft) = ${CalcTemplate.sngMFH.toFixed(2)}</br>`;
    }
  }

  return report;
}

public static LTA_report_subpart_3(): string {
  let report: string = "";

  const component = this.getActiveComponent();
  const isExternalPressure = LTA_module.intLoadingType === 1;
  const isExternalPre = GML_module.isExternalLoading === true;
  const designPressureLabel = isExternalPressure ? "Design pressure or vessel MAEP" : "Design pressure or vessel MAWP";

  if (component.intUnit_select !== 0) {
    // SI
    if (component.intEquip !== 6)
      report += `${designPressureLabel} (MPa) = ${component.sngP_d.toFixed(1)}</br>`;
    else
      report += `Design Maximum Fill Height (m) = ${CalcTemplate.sngMFH_d.toFixed(2)}</br>`;
    if (component.sngTemp_d !== -1)
      report += `Design temperature (deg-C) = ${component.sngTemp_d.toFixed(2)}</br>`;
    else report += `Design temperature (deg-C) = N/A`;
    report += `Inside diameter corrected for FCA as applicable, D (mm) = ${component.sngID.toFixed(1)}</br>`;
    // shameer - new requirement -start
    if (component.intEquip != 6) {
      report += `Nominal Thickness (inch) = ${component.sngtnom.toFixed(3)}</br>`;
    }
    // shameer - new requirement -end

    if (component.intEquip !== 6) {
      // non-tanks
      report += `Current measured (uniform) thickness, trd (mm) = ${component.sngtrd.toFixed(1)}</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (mm) = ${component.sngFCA.toFixed(1)}</br>`;
    } else {
      report += `Current measured (uniform) thickness, trd (mm) = N/A</br>`;
      report += `Future corrosion allowance, FCA = FCAi + FCAe (mm) = N/A</br>`;
    }
    report += `Future corroded thickness, tc (mm) = ${component.sngtc.toFixed(1)}</br>`;
    if (component.intEquip !== 6) {
      report += `Minimum required thickness, tmin (mm) = ${component.sngtmin.toFixed(1)}</br>`;
      report += `MA${isExternalPressure ? "EP" : "WP"} of the component based on tc, MA${isExternalPressure ? "EP" : "WP"} (MPa) = ${component.sngMAWP.toFixed(1)}</br>`;
    } else {
      report += `Maximum Fill Height based on tc, MFH (m) = ${CalcTemplate.sngMFH.toFixed(2)}</br>`;
    }
  }

  report += '<div class="pageBreak"></div>';

  return report;
}

public static LTA_report_subpart_4(reportDate: string): string {
  let report: string = "";
  const isExternalPre = GML_module.isExternalLoading === true;
  const component = this.getActiveComponent();

  if (component.strD_class === "Gouge") {
    report +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 12</center>";
    report += "<center>Assessment of Gouges</center></br></br>";
  } else {
    report +=
      "</br></br><center>API 579-1/ASME FFS-1 Standard 2021 Edition, Part 5</center>";
    if (component.strD_class === "LTA") {
      report += "<center>Assessment of Local Metal Loss</center></br></br>";
    } else {
      report +=
        "<center>Assessment of Local Metal Loss (Profile)</center></br></br>";
    }
  }

  report += reportDate + "</br>";
  report += "Page: 2</br></br></br>";
  if(this.isExternalPre !== true)
  {  
  if (component.sngE_L != null && component.sngE_L !== undefined) {
    report += `Longitudinal weld joint efficiency, E_L = ${component.sngE_L.toFixed(2)}</br>`;
  }

  if ((component.intEquip <= 1 || component.intEquip >= 5) && component.sngE_c != null && component.sngE_c !== undefined) {
    report += `Circumferential weld joint efficiency, E_C = ${component.sngE_c.toFixed(2)}</br>`;
  }
  }
  return report;
}
}
